export default "__VITE_ASSET__DLwGpCP___"